import type { Params } from 'react-router-dom';

// A dynamic `:id` segment is addressable by anyone with a keyboard, and a
// retired address can collide with one (IMM-513: `/workspaces/api-calls` binds
// `/workspaces/:id`). A malformed id is a wrong address, not a fault — refuse it
// with a 404 so the error boundary renders NotFound, before any API round-trip
// turns it into a 400 the boundary reports as an incident.
//
// Version-agnostic on purpose: the ids in play are UUIDv7 and a version-pinned
// regex would reject them. The shape is the guard here; the database is the
// authority on existence (a well-formed id with no row still 404s via the API).
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function requireUuidParam(params: Params, name: string): string {
  const value = params[name];

  // Throw a `Response`, never an `Error`: only `isRouteErrorResponse` + status
  // 404 reaches `NotFoundPage`; a plain `Error` lands on the generic screen,
  // which is the bug. Status 404, never 400 — 400 is what the boundary reports.
  if (typeof value !== 'string' || !UUID.test(value)) {
    throw new Response(`Malformed ${name}`, { status: 404 });
  }

  return value;
}
